import { isFailedTransaction } from '../transactions';

// How long the edit view stays open waiting for a save transaction to resolve.
// Once it elapses the field exits edit view and the read view shows a "we're
// saving your new information..." message instead.
export const CLOSE_MODAL_DELAY = 5000;

// Unit tests set window.VetsGov.pollTimeout to exit the edit view fast enough
// to assert on. Being more aggressive than this (5ms, say) exits before Redux
// has finished processing the update, which surfaces the "we're saving your..."
// message mid-test.
export const TEST_CLOSE_MODAL_DELAY = 50;

export const getCloseModalDelay = () =>
  window.VetsGov?.pollTimeout ? TEST_CLOSE_MODAL_DELAY : CLOSE_MODAL_DELAY;

// PORT NOTE: these predicates return real booleans. The class returned the
// raw `||` result, so `hasError` could yield `undefined` and reach the
// `showErrorAlert` prop that declares `PropTypes.bool`. Every call site used
// the value in a boolean context, so coercing changes nothing but the type.
export const hasError = (transaction, transactionRequest) =>
  !!(transactionRequest?.isFailed || isFailedTransaction(transaction));

export const justClosedModal = (prev, next) =>
  !!(
    (prev.showEditView && !next.showEditView) ||
    (prev.showRemoveModal && !next.showRemoveModal) ||
    (prev.showValidationView && !next.showValidationView)
  );

export const transactionJustFailed = (prev, next) =>
  !hasError(prev.transaction, prev.transactionRequest) &&
  hasError(next.transaction, next.transactionRequest);
